import React from "react";
import { Button, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const slides = [
  {
    id: 1,
    title: "Welcome To DonateGreat",
    subTitle: "Join the mission of hope and fate, great!",
    description:
      "Join our platform to connect with a diverse community of charities and individuals dedicated to making a difference.",
    imageUrl:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/hands-cupping-heart-love-modified.jpg",
    titleStyle: { color: "white", fontSize: "4xl" },
    subTitleStyle: { color: "gray", fontSize: "4xl" },
    contentStyle: { color: "gray", fontSize: "lg" },
  },
  {
    id: 2,
    title: "Every Donation Matters",
    subTitle: "Your small help could bring a big change",
    description:
      "Discover how every single contribution can significantly impact the lives of those in need around the world.",
    imageUrl:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/close-up-people-holding-apples-bag.jpg",
    titleStyle: { color: "yellow", fontSize: "4xl" },
    subTitleStyle: { color: "black", fontSize: "3xl" },
    contentStyle: { color: "black", fontSize: "md" },
  },
  {
    id: 3,
    title: "Volunteer with Us",
    subTitle: "Be a part of our community",
    description:
      "Learn more about how you can volunteer and make a tangible difference in your local and global communities.",
    imageUrl:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/jungle_students.jpg",
    titleStyle: { color: "blue", fontSize: "3xl" },
    subTitleStyle: { color: "white", fontSize: "2xl" },
    contentStyle: { color: "white", fontSize: "sm" },
  },
];

const Hero = () => {
  const navigate = useNavigate();
  const token = Cookies.get("jwtToken");

  return (
    <Carousel effect="fade" dotPosition="right" className="select-none" autoplay speed={1000}>
      {slides.map((slide) => (
        <div key={slide.id}>
          <div
            className="h-screen w-full bg-cover bg-center text-white"
            style={{
              backgroundImage: `url(${slide.imageUrl})`,
            }}
          >
            <div className="flex flex-col justify-center h-full p-4 md:p-12 lg:pt-40">
              <h1
                className={`text-${slide.titleStyle.fontSize} font-display mb-3`}
                style={{
                  fontFamily: "'Playfair Display', serif",
                  color: slide.titleStyle.color,
                }}
              >
                {slide.title}
              </h1>
              <p
                className={`text-${slide.subTitleStyle.fontSize} font-display`}
                style={{
                  fontFamily: "'Playfair Display', serif",
                  color: slide.subTitleStyle.color,
                }}
              >
                {slide.subTitle}
              </p>
              <p
                className={`mt-3 text-${slide.contentStyle.fontSize}`}
                style={{ color: slide.contentStyle.color }}
              >
                {slide.description}
              </p>
              <div className="mt-4">
                {!token && (
                  <Button
                    type="primary"
                    className="bg-btn-1 text-base h-12 px-8"
                    onClick={() => navigate("/register")}
                  >
                    Register Your Charity
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default Hero;